var map = {
	"./abkhazia.svg": "dc6c",
	"./afghanistan.svg": "4a83",
	"./aland-islands.svg": "5f52",
	"./albania.svg": "f063",
	"./algeria.svg": "102b",
	"./american-samoa.svg": "1e90",
	"./andorra.svg": "568f",
	"./angola.svg": "c5e7",
	"./anguilla.svg": "0d6e",
	"./antigua-and-barbuda.svg": "b2ff",
	"./argentina.svg": "497a",
	"./armenia.svg": "06b6",
	"./aruba.svg": "55b9",
	"./australia.svg": "2920",
	"./austria.svg": "03cb",
	"./azerbaijan.svg": "a992",
	"./azores-islands.svg": "c5bf",
	"./bahamas.svg": "ba43",
	"./bahrain.svg": "788b",
	"./balearic-islands.svg": "95b3",
	"./bangladesh.svg": "c153",
	"./barbados.svg": "8904",
	"./basque-country.svg": "c989",
	"./belarus.svg": "98ce",
	"./belgium.svg": "8e0b",
	"./belize.svg": "205d",
	"./benin.svg": "b7a1",
	"./bermuda.svg": "2983",
	"./bhutan-1.svg": "3907",
	"./bhutan.svg": "d8dd",
	"./bolivia.svg": "587e",
	"./bonaire.svg": "3ed1",
	"./bosnia-and-herzegovina.svg": "fe30",
	"./botswana.svg": "aba1",
	"./brazil.svg": "ca76",
	"./british-columbia.svg": "f627",
	"./british-indian-ocean-territory.svg": "646a",
	"./british-virgin-islands.svg": "2ab2",
	"./brunei.svg": "2f4f",
	"./bulgaria.svg": "dd0a",
	"./burkina-faso.svg": "48df",
	"./burundi.svg": "bbf8",
	"./cambodia.svg": "b866",
	"./cameroon.svg": "6285",
	"./canada.svg": "b5e4",
	"./canary-islands.svg": "6c02",
	"./cape-verde.svg": "48a3",
	"./cayman-islands.svg": "be55",
	"./central-african-republic.svg": "de9a",
	"./ceuta.svg": "dc1a",
	"./chad.svg": "7da4",
	"./chile.svg": "5386",
	"./china.svg": "87e6",
	"./christmas-island.svg": "9bc5",
	"./cocos-island.svg": "fb21",
	"./colombia.svg": "6c98",
	"./comoros.svg": "7aad",
	"./cook-islands.svg": "9ea7",
	"./corsica.svg": "4cc6",
	"./costa-rica.svg": "94ef",
	"./croatia.svg": "4bc6",
	"./cuba.svg": "6fb2",
	"./curacao.svg": "f213",
	"./cyprus.svg": "26cf",
	"./czech-republic.svg": "ec38",
	"./democratic-republic-of-congo.svg": "2de8",
	"./denmark.svg": "7863",
	"./djibouti.svg": "c567",
	"./dominica.svg": "5654",
	"./dominican-republic.svg": "9802",
	"./east-timor.svg": "0316",
	"./ecuador.svg": "c7fd",
	"./egypt.svg": "e199",
	"./england.svg": "2533",
	"./equatorial-guinea.svg": "7384",
	"./eritrea.svg": "4b47",
	"./estonia.svg": "b68b",
	"./ethiopia.svg": "0138",
	"./european-union.svg": "4f9d",
	"./falkland-islands.svg": "1620",
	"./faroe-islands.svg": "da7c",
	"./fiji.svg": "ce38",
	"./finland.svg": "b44c",
	"./france.svg": "269f",
	"./french-polynesia.svg": "2cfe",
	"./gabon.svg": "4c01",
	"./galapagos-islands.svg": "8cf9",
	"./gambia.svg": "35cc",
	"./georgia.svg": "b915",
	"./germany.svg": "35ae",
	"./ghana.svg": "ec20",
	"./gibraltar.svg": "3bbd",
	"./greece.svg": "b27f",
	"./greenland.svg": "c96f",
	"./grenada.svg": "7c93",
	"./guam.svg": "0fb2",
	"./guatemala.svg": "8311",
	"./guernsey.svg": "75f8",
	"./guinea-bissau.svg": "a076",
	"./guinea.svg": "5955",
	"./guyana.svg": "9d69",
	"./haiti.svg": "d09b",
	"./hawaii.svg": "b4b9",
	"./honduras.svg": "1306",
	"./hong-kong.svg": "f8da",
	"./hungary.svg": "1c40",
	"./iceland.svg": "25d7",
	"./india.svg": "169d",
	"./indonesia.svg": "6456",
	"./iran.svg": "b126",
	"./iraq.svg": "092f",
	"./ireland.svg": "e505",
	"./isle-of-man.svg": "0b43",
	"./israel.svg": "8e23",
	"./italy.svg": "5854",
	"./ivory-coast.svg": "2e69",
	"./jamaica.svg": "bad4",
	"./japan.svg": "34db",
	"./jersey.svg": "78d4",
	"./jordan.svg": "a230",
	"./kazakhstan.svg": "4829",
	"./kenya.svg": "f9dd",
	"./kiribati.svg": "0718",
	"./kosovo.svg": "ccf5",
	"./kuwait.svg": "9914",
	"./kyrgyzstan.svg": "0142",
	"./laos.svg": "5978",
	"./latvia.svg": "92ba",
	"./lebanon.svg": "7a68",
	"./lesotho.svg": "6912",
	"./liberia.svg": "c181",
	"./libya.svg": "57e1",
	"./liechtenstein.svg": "944c",
	"./lithuania.svg": "02ea",
	"./luxembourg.svg": "91cf",
	"./macao.svg": "7eef",
	"./madagascar.svg": "c85a",
	"./madeira.svg": "39c6",
	"./malawi.svg": "6296",
	"./malaysia.svg": "a003",
	"./maldives.svg": "1c24",
	"./mali.svg": "ce9b",
	"./malta.svg": "8a27",
	"./marshall-island.svg": "67f0",
	"./martinique.svg": "90b3",
	"./mauritania.svg": "5db0",
	"./mauritius.svg": "ec3f",
	"./melilla.svg": "d922",
	"./mexico.svg": "c3cc",
	"./micronesia.svg": "c792",
	"./moldova.svg": "9bb5",
	"./monaco.svg": "6e8f",
	"./mongolia.svg": "455b",
	"./montenegro.svg": "32dd",
	"./montserrat.svg": "0633",
	"./morocco.svg": "7437",
	"./mozambique.svg": "32c8",
	"./myanmar.svg": "d376",
	"./namibia.svg": "022b",
	"./nato.svg": "371f",
	"./nauru.svg": "04d7",
	"./nepal.svg": "af13",
	"./netherlands.svg": "7a0a",
	"./new-zealand.svg": "f5e5",
	"./nicaragua.svg": "d5ea",
	"./niger.svg": "5b6f",
	"./nigeria.svg": "5cf3",
	"./niue.svg": "5ef5",
	"./norfolk-island.svg": "0fc4",
	"./north-korea.svg": "28fa",
	"./northen-cyprus.svg": "d291",
	"./northern-marianas-islands.svg": "3167",
	"./norway.svg": "b9d2",
	"./oman.svg": "0d0f",
	"./orkney-islands.svg": "96fe",
	"./ossetia.svg": "0908",
	"./pakistan.svg": "0891",
	"./palau.svg": "d42f",
	"./palestine.svg": "afbd",
	"./panama.svg": "2f21",
	"./papua-new-guinea.svg": "b602",
	"./paraguay.svg": "261d",
	"./peru.svg": "acd7",
	"./philippines.svg": "5120",
	"./pitcairn-islands.svg": "08d6",
	"./portugal.svg": "f975",
	"./puerto-rico.svg": "ef8f",
	"./qatar.svg": "0177",
	"./rapa-nui.svg": "454e",
	"./republic-of-macedonia.svg": "6505",
	"./republic-of-poland.svg": "3e88",
	"./republic-of-the-congo.svg": "924a",
	"./romania.svg": "cd40",
	"./russia.svg": "0308",
	"./rwanda.svg": "ce82",
	"./saba-island.svg": "fc0e",
	"./saint-kitts-and-nevis.svg": "19bd",
	"./salvador.svg": "23b0",
	"./samoa.svg": "2691",
	"./san-marino.svg": "3e55",
	"./sao-tome-and-principe.svg": "081b",
	"./sardinia.svg": "4910",
	"./saudi-arabia.svg": "e9e9",
	"./scotland.svg": "41e2",
	"./senegal.svg": "2f1b",
	"./serbia.svg": "b313",
	"./seychelles.svg": "09b7",
	"./sierra-leone.svg": "0911",
	"./singapore.svg": "4df3",
	"./sint-eustatius.svg": "876a",
	"./sint-maarten.svg": "59f6",
	"./slovakia.svg": "3e1f",
	"./slovenia.svg": "f88c",
	"./solomon-islands.svg": "05a5",
	"./somalia.svg": "f380",
	"./somaliland.svg": "dda6",
	"./south-africa.svg": "7582",
	"./south-korea.svg": "190e",
	"./south-sudan.svg": "c451",
	"./spain.svg": "d4b4",
	"./sri-lanka.svg": "2f81",
	"./st-barts.svg": "49f5",
	"./st-lucia.svg": "1cc5",
	"./st-vincent-and-the-grenadines.svg": "6ca2",
	"./sudan.svg": "d9da",
	"./suriname.svg": "bf10",
	"./swaziland.svg": "2938",
	"./sweden.svg": "6d1f",
	"./switzerland.svg": "9363",
	"./syria.svg": "2078",
	"./taiwan.svg": "1e8b",
	"./tajikistan.svg": "cdf6",
	"./tanzania.svg": "b16e",
	"./thailand.svg": "9180",
	"./tibet.svg": "cf10",
	"./togo.svg": "6b4a",
	"./tokelau.svg": "c359",
	"./tonga.svg": "bf9e",
	"./transnistria.svg": "ee21",
	"./trinidad-and-tobago.svg": "efa3",
	"./tunisia.svg": "1442",
	"./turkey.svg": "bb3f",
	"./turkmenistan.svg": "e66d",
	"./turks-and-caicos.svg": "c58f",
	"./tuvalu.svg": "514e",
	"./uganda.svg": "a143",
	"./ukraine.svg": "ab66",
	"./united-arab-emirates.svg": "dc1d",
	"./united-kingdom.svg": "6333",
	"./united-nations.svg": "1b56",
	"./united-states-of-america.svg": "875c",
	"./uruguay.svg": "c60e",
	"./uzbekistn.svg": "b4de",
	"./vanuatu.svg": "bf4e",
	"./vatican-city.svg": "30ad",
	"./venezuela.svg": "8c49",
	"./vietnam.svg": "f035",
	"./virgin-islands.svg": "14c0",
	"./wales.svg": "b238",
	"./western-sahara.svg": "a724",
	"./yemen.svg": "ac8b",
	"./zambia.svg": "3760",
	"./zimbabwe.svg": "d45b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c636";